export default {
      id: "text-usage",
      viewBox: "0 0 200 167",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#text",
      toString: function () {
        return this.url;
      }
    }